import React, { Component } from "react";
import {
  Button,
  Container,
  Row,
  Col,
  Card,
  Form,
  Alert,
  Modal,
  ProgressBar,
  Badge
} from "react-bootstrap";
import { toast } from "react-toastify";
import configData from '../config.json';

import LoadingOverlay from "./LoadingOverlay";
export default class HealthMemberExport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      companies: [],
      insuranceCompanies: [],
      selectedCompany: '',
      selectedCompanyName: '',
      selectedInsuranceCompany: '',
      selectedInsuranceCompanyName: '',
      isLoadingCompanies: false,
      isLoadingInsuranceCompanies: false,
      isExporting: false,
      showExportModal: false,
      exportProgress: 0,
      exportResults: null,
      errors: {}
    };
  }

  componentDidMount() {
    this.loadCompanies();
    this.loadInsuranceCompanies();
  }

  // Load companies from API (from 'company' table - singular)
  loadCompanies = () => {
    this.setState({ isLoadingCompanies: true });
    
    const formData = new FormData();
    formData.append('sId', this.state.sId);
    formData.append('uId', this.state.uId);

    // Loading from 'company' table (singular) for employers
    fetch(configData.api_url + 'C_Company/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
    .then(response => response.json())
    .then((data) => {
      this.setState({ isLoadingCompanies: false });
      
      if (data.status === "success") {
        this.setState({ companies: data.list || [] });
      } else {
        this.showToast(data.message || 'Failed to load companies', 'error');
      }
    })
    .catch((error) => {
      this.setState({ isLoadingCompanies: false });
      this.showToast('Error loading companies: ' + error.message, 'error');
    });
  };

  // Load insurance companies from API (from 'companies' table - plural)
  loadInsuranceCompanies = () => {
    this.setState({ isLoadingInsuranceCompanies: true });
    
    const formData = new FormData();
    formData.append('sId', this.state.sId);
    formData.append('uId', this.state.uId);

    // Loading from 'companies' table (plural) for insurance companies
    fetch(configData.api_url + 'Companies/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
    .then(response => response.json())
    .then((data) => {
      this.setState({ isLoadingInsuranceCompanies: false });
      
      if (data.status === "success") {
        this.setState({ insuranceCompanies: data.list || [] });
      } else {
        this.showToast(data.message || 'Failed to load insurance companies', 'error');
      }
    })
    .catch((error) => {
      this.setState({ isLoadingInsuranceCompanies: false });
      this.showToast('Error loading insurance companies: ' + error.message, 'error');
    });
  };

  // Handle company selection
  handleCompanyChange = (e) => {
    const selectedCompanyId = e.target.value;
    const selectedCompany = this.state.companies.find(company => company.company_Id === selectedCompanyId);
    
    this.setState({
      selectedCompany: selectedCompanyId,
      selectedCompanyName: selectedCompany ? selectedCompany.companyName : '',
      errors: { ...this.state.errors, company: '' }
    });
  };

  // Handle insurance company selection
  handleInsuranceCompanyChange = (e) => {
    const selectedInsuranceCompanyId = e.target.value;
    const selectedInsuranceCompany = this.state.insuranceCompanies.find(company => company.cId === selectedInsuranceCompanyId);
    
    this.setState({
      selectedInsuranceCompany: selectedInsuranceCompanyId,
      selectedInsuranceCompanyName: selectedInsuranceCompany ? selectedInsuranceCompany.cName : '',
      errors: { ...this.state.errors, insuranceCompany: '' }
    });
  };

  // Validate form
  validateForm = () => {
    const errors = {};
    
    if (!this.state.selectedCompany) {
      errors.company = 'Please select a company';
    }
    
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  // Show export modal
  showExportModal = () => {
    if (this.validateForm()) {
      this.setState({ showExportModal: true });
    }
  };

  // Hide export modal
  hideExportModal = () => {
    this.setState({ 
      showExportModal: false,
      exportProgress: 0,
      exportResults: null 
    });
  };

  // Export Excel with PED answers
  exportExcel = () => {
    if (!this.validateForm()) {
      return;
    }

    this.setState({ isExporting: true, exportProgress: 0 });
    
    const formData = new FormData();
    formData.append('sId', this.state.sId);
    formData.append('companyId', this.state.selectedCompany);
    if (this.state.selectedInsuranceCompany) {
      formData.append('insuranceCompanyId', this.state.selectedInsuranceCompany);
    }

    // Simulate progress
    const progressInterval = setInterval(() => {
      this.setState(prevState => ({
        exportProgress: Math.min(prevState.exportProgress + 10, 90)
      }));
    }, 200);

    fetch(configData.api_url + 'C_Healthmemberdata/export_excel_with_ped_answers', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
    .then(response => response.json())
    .then((data) => {
      clearInterval(progressInterval);
      this.setState({ isExporting: false, exportProgress: 100 });
      
      if (data.status === "success") {
        this.setState({ exportResults: data });
        this.showToast('Excel export generated successfully!', 'success');
        
        // Auto-download the file
        setTimeout(() => {
          window.open(data.download_url, '_blank');
        }, 1000);
      } else {
        this.showToast(data.message || 'Export failed', 'error');
      }
    })
    .catch((error) => {
      clearInterval(progressInterval);
      this.setState({ isExporting: false, exportProgress: 0 });
      this.showToast('Export failed: ' + error.message, 'error');
    });
  };

  // Show toast notification
  showToast = (message, type) => {
    if (type === 'success') {
      toast.success(message);
    } else {
      toast.error(message);
    }
  };

  render() {
    const { companies, insuranceCompanies, selectedCompany, selectedCompanyName, 
            selectedInsuranceCompany, selectedInsuranceCompanyName,
            isLoadingCompanies, isLoadingInsuranceCompanies,
            isExporting, showExportModal, exportProgress, exportResults, errors } = this.state;

    return (
      <div className="page-wrapper">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Health Member Data Export</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="index.html">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">Health Member Export</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8 offset-md-2">
              <Card>
                <Card.Header>
                  <h5 className="card-title">Export Health Member Data with PED Answers</h5>
                </Card.Header>
                <Card.Body>
                  <Alert variant="info">
                    <h6>Export Features:</h6>
                    <ul>
                      <li>Complete health member data with PED questionnaire answers</li>
                      <li>Filter PED questions by insurance company (optional)</li>
                      <li>All dates formatted in dd-mm-yyyy format</li>
                      <li>Month entries in mm-yyyy format</li>
                      <li>PED answers showing "Yes" instead of "1"</li>
                      <li>PED questions ordered by Question ID</li>
                      <li>CSV format for Excel compatibility</li>
                    </ul>
                  </Alert>

                  <Form>
                    <Row>
                      <Col md={12}>
                        <Form.Group className="mb-3">
                          <Form.Label>Select Company (Employer) <span className="text-danger">*</span></Form.Label>
                          <Form.Select
                            value={selectedCompany}
                            onChange={this.handleCompanyChange}
                            disabled={isLoadingCompanies}
                            className={errors.company ? 'is-invalid' : ''}
                          >
                            <option value="">
                              {isLoadingCompanies ? 'Loading companies...' : 'Select a company'}
                            </option>
                            {companies.map(company => (
                              <option key={company.company_Id} value={company.company_Id}>
                                {company.companyName}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.company && (
                            <div className="invalid-feedback">
                              {errors.company}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <Form.Group className="mb-3">
                          <Form.Label>Select Insurance Company (Insurer) <span className="text-muted">(Optional)</span></Form.Label>
                          <Form.Select
                            value={selectedInsuranceCompany}
                            onChange={this.handleInsuranceCompanyChange}
                            disabled={isLoadingInsuranceCompanies}
                            className={errors.insuranceCompany ? 'is-invalid' : ''}
                          >
                            <option value="">
                              {isLoadingInsuranceCompanies ? 'Loading companies...' : 'All Insurance Companies (Show All PED Questions)'}
                            </option>
                            {insuranceCompanies.map(company => (
                              <option key={company.cId} value={company.cId}>
                                {company.cName}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.insuranceCompany && (
                            <div className="invalid-feedback">
                              {errors.insuranceCompany}
                            </div>
                          )}
                          <Form.Text className="text-muted">
                            Select an insurance company to filter PED questions specific to that insurer. (Loaded from 'companies' table)
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>

                    {selectedCompany && (
                      <Alert variant="success">
                        <strong>Selected Company:</strong> {selectedCompanyName}
                        <br />
                        <strong>Company ID:</strong> {selectedCompany}
                        {selectedInsuranceCompany && (
                          <>
                            <br />
                            <strong>Insurance Company:</strong> {selectedInsuranceCompanyName}
                            <br />
                            <strong>Insurance Company ID:</strong> {selectedInsuranceCompany}
                          </>
                        )}
                      </Alert>
                    )}

                    <div className="text-center mt-4">
                      <Button 
                        variant="primary" 
                        size="lg"
                        onClick={this.showExportModal}
                        disabled={!selectedCompany || isLoadingCompanies}
                      >
                        <i className="bi bi-download"></i> Export to Excel
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </div>
          </div>

          {/* Export Confirmation Modal */}
          <Modal show={showExportModal} onHide={this.hideExportModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Export</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to export health member data for:</p>
              <Alert variant="info">
                <strong>Company:</strong> {selectedCompanyName}<br />
                <strong>Company ID:</strong> {selectedCompany}
                {selectedInsuranceCompany && (
                  <>
                    <br />
                    <strong>Insurance Company:</strong> {selectedInsuranceCompanyName}<br />
                    <strong>Insurance Company ID:</strong> {selectedInsuranceCompany}
                  </>
                )}
              </Alert>
              <p>The export will include:</p>
              <ul>
                <li>All health member data for the selected company</li>
                <li>{selectedInsuranceCompany 
                    ? `PED questions specific to ${selectedInsuranceCompanyName}` 
                    : 'All PED questionnaire answers'}</li>
                <li>PED answers showing "Yes" instead of "1"</li>
                <li>Properly formatted dates and entries</li>
              </ul>
              
              {isExporting && (
                <div className="mt-3">
                  <p>Generating export...</p>
                  <ProgressBar 
                    now={exportProgress} 
                    label={`${exportProgress}%`}
                    className="mb-2"
                  />
                </div>
              )}

              {exportResults && (
                <Alert variant="success" className="mt-3">
                  <h6>Export Successful!</h6>
                  <p><strong>Records Exported:</strong> {exportResults.record_count}</p>
                  {exportResults.ped_question_count !== undefined && (
                    <p><strong>PED Questions Included:</strong> {exportResults.ped_question_count}</p>
                  )}
                  <p><strong>File:</strong> {exportResults.filename}</p>
                  <p>Download will start automatically...</p>
                </Alert>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.hideExportModal} disabled={isExporting}>
                {isExporting ? 'Exporting...' : 'Cancel'}
              </Button>
              <Button 
                variant="primary" 
                onClick={this.exportExcel}
                disabled={isExporting || exportResults}
              >
                {isExporting ? 'Exporting...' : 'Confirm Export'}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}